<template>
  <div>
    <as-dialogo ref="cores" title="Cores" max-width="600px" altura="500px">
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-text-field
            ref="pesquisa"
            label="Pesquisa"
            dense
            class="mr-4"
            v-model="pesquisa"
            prepend-inner-icon="search"
            solo
            clearable
            single-line
            hide-details
            placeholder="Pesquisa"
            dark
            background-color="primary lighten-2"
            @click:clear="tooglePesquisa"
          ></v-text-field>
          <v-btn
            depressed
            class="hidden-xs-only"
            color="primary lighten-4"
            @click="abrirDialogoCadastro"
            >Adicionar</v-btn
          >
          <v-btn
            fab
            small
            color="primary lighten-4"
            @click="abrirDialogoCadastro"
            class="hidden-sm-and-up"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="cores"
          hide-default-footer
          :loading="loading"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.nome }}</td>
              <td class="justify-center align-center layout px-0">
                <v-menu bottom left v-if="item.tipo == 0">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="editar(item)">
                      <v-list-item-title>
                        <v-icon class="pr-4">edit</v-icon>Editar
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="abrirDialogoExcluir(item)">
                      <v-list-item-title>
                        <v-icon class="pr-4">delete</v-icon>Excluir
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </as-dialogo>

    <as-dialogo
      ref="dialogoCadastro"
      title="Cadastro de Cor"
      max-width="400px"
      semPadding
      hideCloseButton
      hideDivider
    >
      <v-form ref="form" v-model="form_valid" lazy-validation>
        <v-row dense class="pa-4">
          <v-col cols="12">
            <v-text-field
              label="Nome"
              ref="nome"
              v-model="cor.nome"
              @keydown.prevent.enter="salvar"
              :rules="regras.nome"
              @input="(value) => (cor.nome = value.toUpperCase())"
              autofocus
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoCadastro.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="salvar"
          :loading="loading"
          :disabled="loading || !form_valid"
          >Salvar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoExcluir"
      title="Excluir"
      max-width="440px"
      hideCloseButton
      hideDivider
    >
      <v-label>Tem certeza que deseja excluir essa cor?</v-label>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluir"
          :disabled="excluindo"
          :loading="excluindo"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import Services from "../../services/services.js";
import ServiceCores from "../../services/cores.js";

export default {
  name: "Cores",
  data() {
    return {
      exibirPesquisa: false,
      loading: false,
      excluindo: false,
      pesquisa: "",
      headers: [
        { text: "Nome", value: "nome", width: "95%", sortable: false },
        { text: "", value: "", width: "5%", sortable: false },
      ],
      cores: [],
      user: {},
      cor: {},
      form_valid: false,
      regras: {
        nome: [(value) => !!value || "Campo Obrigatório"],
      },
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 50);
      }
    },
    abrir() {
      this.$refs.cores.abrir();
    },
    abrirDialogoCadastro() {
      this.cor = {};
      this.$refs.dialogoCadastro.abrir();
    },
    async listar() {
      try {
        this.loading = true;
        let response_cores = await ServiceCores.listar(this.user.fornecedor_id);
        this.cores = response_cores.data.cores;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar cores", error);
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;

          if (this.cor.id) {
            await ServiceCores.atualizar(this.cor.id, this.cor);
            this.$eventbus.notificar("Cor atualizada com sucesso");
          } else {
            await ServiceCores.salvar(this.cor);
            this.$eventbus.notificar("Cor salva com sucesso");
          }
        } catch (error) {
          this.$eventbus.erro(
            error.response?.data?.message ||
              error.response?.data?.msg ||
              "Erro ao salvar a cor",
            error
          );
        } finally {
          this.loading = false;
          this.listar();
          this.$refs.dialogoCadastro.fechar();
          this.cor = {};
        }
      }
    },
    editar(cor) {
      this.cor = this.clone(cor);
      this.$refs.dialogoCadastro.abrir();
    },
    abrirDialogoExcluir(cor) {
      this.cor = this.clone(cor);
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;

        let response = await ServiceCores.excluir(this.cor.id);

        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listar();
          this.cor = {};
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$$eventbus.erro("Erro ao excluir cor", error);
      } finally {
        this.excluindo = false;
        this.$refs.dialogoExcluir.fechar();
      }
    },
  },
  computed: {},
};
</script>

<style></style>
